import React from "react";

const CardSecondary = (props) => {
  let classes = "CardSeconday position-relative";

  if (props.className) {
    classes = classes + " " + props.className;
  }

  return (
    <section className={classes} onClick={props.onClick || null} style={props.style}>
      {props.children}
    </section>
  );
};

export default CardSecondary;
